import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Compare Before You Buy | UK Mobile & Internet Support | Call 0800 652 1866",
  description = "Independent UK mobile & internet support experts. Get help with SIM issues, network problems, billing, upgrades & more. Free helpline: 0800 652 1866. Available 7 days a week.",
  keywords = "UK mobile support, SIM card help, network problems, mobile internet support, broadband help UK, billing queries, mobile advice UK, 0800 support",
  ogImage = "https://images.unsplash.com/photo-1663245482988-22fad02654e3?w=1200&h=630&fit=crop",
  url = "https://comparebeforeyoubuy.shop",
  type = "website"
}) => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Compare Before You Buy",
    "url": "https://comparebeforeyoubuy.shop",
    "logo": "https://images.unsplash.com/photo-1663245482988-22fad02654e3?w=400&h=400&fit=crop",
    "description": "Independent UK mobile and internet support service",
    "telephone": "+44-800-652-1866",
    "email": "contact@comparebeforeyoubuy.shop"
  };

  // Remove ElectronicsStore schema - replace with comparison service
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Compare Before You Buy",
    "url": "https://comparebeforeyoubuy.shop",
    "description": "Independent smartphone comparison platform helping UK consumers find the best mobile phone deals",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://comparebeforeyoubuy.shop/?s={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://comparebeforeyoubuy.shop"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Products",
        "item": "https://comparebeforeyoubuy.shop#products"
      }
    ]
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Compare Before You Buy" />
      <meta property="og:locale" content="en_GB" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Additional SEO Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="Compare Before You Buy" />
      <meta name="geo.region" content="GB-DWN" />
      <meta name="geo.placename" content="Newtownards" />
      <meta name="geo.position" content="54.5916;-5.6958" />
      <meta name="ICBM" content="54.5916, -5.6958" />
      
      {/* Mobile */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#2563eb" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default SEO;
